export var warningDisposal = {
  name: "预警处置",
  path: "/warningDisposal",
  hidden: false,
  redirect: "noredirect",
  component: "Layout",
  elemCode: "21",
  sort: 7,
  meta: {
    title: "预警处置",
    icon: "alert-triangle-outline",
    noCache: false
  },
  children: [{
    name: "预警处置",
    path: "/warningDisposal",
    hidden: false,
    component: "warningDisposal/index",
    elemCode: "210",
    meta: {
      title: "预警处置",
      noCache: true
    }
  }]
};